const messages = {
    title: "Rapport genereren",
    personal_data: {
        title: "Persoonlijke gegevens",
        email: "E-mail",
        salutation: "Aanhef",
        first_name: "Voornaam",
        last_name: "Achternaam",
        job_position: "Functie in het bedrijf"
    },
    shipping_address: {
        title: "Leveringsadres",
        company: "Bedrijfsnaam",
        street: "Huisnummer en straat",
        postal_code: "Postcode",
        mobile_phone: "Mobiele telefoon",
        iban_number: "IBAN",
        vat: "Btw-nummer",
        additional_address: "Aanvullend adres",
        city: "Plaats"
    },
    operating_data: {
        title: "Operationele gegevens",
        customer_number: "Klantnummer",
        group: "Groep",
        customer_group: "Groep",
        first_registration: "Eerste registratie",
        last_login: "Laatste aanmelding",
        tires_per_year: "Banden per jaar",
        over_18_inch: "Meer dan 18 inch",
        premium: "Premium",
        middle: "Middenklasse",
        summer: "Zomer",
        winter: "Winter",
        all_season: "Vier seizoenen"
    },
    calculatedData: "Gegevens type",
    calculated_data: {
        title: "Berekende gegevens",
        tireAmount: "Aantal banden",
        points: "Punten",
        bonus: "Bonus"
    },
    sales_structure: {
        title: "Verkoopstructuur",
        sales_representative: {
            title: "Vertegenwoordiger",
        },
        distributor: {
            title: "Distributeur",
        },
    },
    meta: {
        title: "Metagegevens",
        brand: {
            title: "Merk",
            none: ''
        },
        tireType: {
            title: "Banden type",
            none: ''
        },
        year: {
            title: "Jaar",
            "2020": "2020",
            "2021": "2021",
            "2022": "2022",
            "2023": "2023",
            "2024": "2024",
            "2025": "2025"
        },
        calendarMonth: {
            title: "Kalendermaand",
            january: "Januari",
            february: "Februari",
            march: "Maart",
            april: "April",
            may: "Mei",
            june: "Juni",
            july: "Juli",
            august: "Augustus",
            september: "September",
            october: "Oktober",
            november: "November",
            december: "December"
        },
    },
    selectAll: "Alles selecteren",
    reset: "Filters resetten",
    generate: "Rapport genereren",
    loadingInfo: "Rapport wordt gegenereerd, even geduld...",
    downloadingTitle: "Gegevens van deelnemende klanten worden gedownload",
    filterInstruction: "Stel uw selectiefilter in:",
    downloads: "Downloads",
    validation: {
        distributorRequired: "Selecteer minstens één optie",
    }
};

export default {
    messages,
};
